import ko from "knockout";
import manifestManager from "flow/utils/manifestManager";
import MyFlow from "flow/MyFlow";

interface IModule {
    moduleId: string;
    moduleName: string;
    subMenuVisible: KnockoutObservable<boolean>;
    toggleSubMenuVisibility: () => void;
    subModule: KnockoutObservableArray<ISubModule>;
}

interface ISubModule {
    id: string;
    name: string;
    baseUrl: string;
    onSelect: (subModule: ISubModule) => void;
}

function ConfigMenu(myFlow: MyFlow) {
    const modules = ko.observableArray([]);
    function activate() {
        if (modules().length == 0) {
            const configItemManifest = manifestManager.getConfigItemManifests();
            for (let i = 0; i < configItemManifest.length; i++) {
                let inserted = false;
                const module: IModule = {
                    moduleId: configItemManifest[i].moduleId,
                    moduleName: myFlow.translate(configItemManifest[i].configItem.groupName),
                    subMenuVisible: ko.observable(false),
                    toggleSubMenuVisibility: function () {
                        this.subMenuVisible(!this.subMenuVisible());
                    },
                    subModule: ko.observableArray([])
                };
                const subModule: ISubModule = {
                    id: configItemManifest[i].id,
                    name: myFlow.translate(configItemManifest[i].configItem.name),
                    baseUrl: configItemManifest[i].baseUrl,
                    onSelect: function (subMod) {
                        myFlow.activateById(subMod.id);
                    }
                };
                if (modules().length > 0) {
                    for (let j = 0; j < modules().length; j++) {
                        if (modules()[j].moduleName == myFlow.translate(configItemManifest[i].configItem.groupName)) {
                            addSubModules(j, subModule);
                            inserted = true;
                            break;
                        }
                    }
                    if (inserted == false) {
                        module.subModule.push(subModule);
                        modules.push(module);
                    }
                } else {
                    addModules(module);
                    addSubModules(0, subModule);
                }
            }
            if (modules().length === 1) {
                modules()[0].subMenuVisible(true);
            }
        }
    }

    function addModules(module: IModule) {
        modules.push(module);
    }

    function addSubModules(moduleIndex: number, subModule: ISubModule) {
        modules()[moduleIndex].subModule.push(subModule);
    }

    return {
        activate: activate,
        modules: modules
    };
}

export default ConfigMenu;
